/*
 * Purogy custom bundle / quantity-break selector. Every tier is sold as a
 * subscription, so the matching selling plan is always attached.
 * Supports multiple pickers on the page (buybox + stock-up) that stay in sync.
 */
(function () {
  if (window.__purogyBundleInit) return;
  window.__purogyBundleInit = true;

  var scopes = Array.prototype.slice.call(document.querySelectorAll('[data-purogy-purchase]'));
  if (!scopes.length) return;

  var primary = scopes[0];

  function allCards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-purogy-bundle]'));
  }

  function cardsIn(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-purogy-bundle]'));
  }

  function planNumericId(gid) {
    if (!gid) return '';
    var m = String(gid).match(/(\d+)$/);
    return m ? m[1] : '';
  }

  function planInput(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }
    return input;
  }

  function setPlan(form, planId) {
    var input = planInput(form);
    if (!input) return;
    if (planId) {
      input.value = planId;
      input.disabled = false;
    } else {
      input.value = '';
      input.disabled = true;
    }
  }

  function allForms() {
    return Array.prototype.slice.call(
      document.querySelectorAll('product-form form, form[data-type="add-to-cart-form"], form[data-purogy-form]')
    );
  }

  function renderPrice(el, text) {
    if (!el) return;
    var s = String(text || '').trim();
    /* [currency symbol][whole number][.cents] — symbol and cents get their
       own (smaller) spans */
    var pm = s.match(/^([^\d-]*)([\d.,]*?)(\.\d{2})?$/);
    if (!pm || !pm[2]) {
      el.textContent = s;
      return;
    }
    el.innerHTML = '';
    if (pm[1]) {
      var cur = document.createElement('span');
      cur.className = 'purogy-cur';
      cur.textContent = pm[1];
      el.appendChild(cur);
    }
    el.appendChild(document.createTextNode(pm[2]));
    if (pm[3]) {
      var cents = document.createElement('span');
      cents.className = 'purogy-cents';
      cents.textContent = pm[3];
      el.appendChild(cents);
    }
  }

  function updatePriceBox(box, priceText, compareText) {
    if (!box) return;
    var now = box.querySelector('[data-purogy-now]');
    var was = box.querySelector('[data-purogy-was]');
    if (now) renderPrice(now, priceText);
    if (was) {
      if (compareText) {
        was.textContent = compareText;
        was.hidden = false;
      } else {
        was.textContent = '';
        was.hidden = true;
      }
    }
  }

  function refreshCards() {
    allCards().forEach(function (card) {
      var price = card.getAttribute('data-sub-price');
      var compare = card.getAttribute('data-sub-compare');

      var priceEl = card.querySelector('.purogy-bundle__price');
      var compareEl = card.querySelector('.purogy-bundle__compare');

      if (priceEl && price) renderPrice(priceEl, price);
      if (compareEl) {
        var showCompare = compare && compare !== price;
        compareEl.textContent = compare;
        compareEl.hidden = !showCompare;
      }
    });
  }

  function syncSelection(variantId) {
    allCards().forEach(function (card) {
      var match = card.getAttribute('data-variant-id') === variantId;
      card.classList.toggle('is-selected', match);
      var radio = card.querySelector('.purogy-bundle__radio');
      if (radio) radio.checked = match;
    });
  }

  /* free-gift board: a tile stays locked until its tier is selected */
  function syncGifts(rank) {
    var tier = Number(rank) || 1;
    document.querySelectorAll('[data-purogy-gift]').forEach(function (gift) {
      var locked = tier < Number(gift.getAttribute('data-min-rank') || 1);
      gift.classList.toggle('is-locked', locked);
    });
  }

  function apply(card) {
    if (!card) return;
    var variantId = card.getAttribute('data-variant-id');
    var priceText = card.getAttribute('data-sub-price');
    var compareText = card.getAttribute('data-sub-compare');
    var showCompare = compareText && compareText !== priceText ? compareText : '';
    var planId = planNumericId(card.getAttribute('data-sub-plan'));
    var interval = card.getAttribute('data-interval');

    syncSelection(variantId);
    syncGifts(card.getAttribute('data-rank'));

    allForms().forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = variantId;
        input.removeAttribute('disabled');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setPlan(form, planId);
    });

    document.querySelectorAll('[data-purogy-atc-price]').forEach(function (box) {
      updatePriceBox(box, priceText, showCompare);
    });
    document.querySelectorAll('[data-purogy-sticky-price]').forEach(function (box) {
      updatePriceBox(box, priceText, showCompare);
    });

    if (interval) {
      document.querySelectorAll('[data-purogy-interval]').forEach(function (el) {
        el.textContent = interval;
      });
    }
  }

  function selectedCard() {
    var checked = primary.querySelector('.purogy-bundle__radio:checked');
    if (checked) return checked.closest('[data-purogy-bundle]');
    var cards = cardsIn(primary);
    return cards[0] || allCards()[0];
  }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('purogy-bundle__radio')) return;
    apply(e.target.closest('[data-purogy-bundle]'));
  });

  var checked = primary.querySelector('.purogy-bundle__radio:checked') || primary.querySelector('.purogy-bundle__radio:not([disabled])');
  if (checked) checked.checked = true;
  refreshCards();
  apply(selectedCard());
})();
